export const FILTER_VALUE_SEPARATOR = ', '
